export const currency = (value, options = {}, locale = 'nl-NL') => {
    const hasDecimals = value % 1 !== 0;

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
        ...options
    }).format(value);
};
